export default {
    wizardType: "BIGQUERY",

    getJDBCURL: (m) => m.get("connectionUrl"),

    getConnectionParams: (type, model) => ({
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
        connectionUrl: model.get("connectionUrl"),
    }),
};

